/**
 * Размеры изображений промптов
 */
export enum ImageSize {
    Small = 'small',
    Medium = 'medium',
    Big = 'big',
}

/**
 * Маппинг размеров на суффиксы URL
 */
const sizeSuffixes: Record<ImageSize, string> = {
    [ImageSize.Small]: '/256x256',
    [ImageSize.Medium]: '/width_768_q70',
    [ImageSize.Big]: '/width_1280_q80',
};

/**
 * Формирует URL изображения с нужным размером
 *
 * @param baseUrl - Базовый URL изображения (без суффикса размера)
 * @param size - Размер изображения (по умолчанию ImageSize.Medium)
 * @returns URL изображения с суффиксом размера или undefined, если baseUrl не передан
 *
 * @example
 * ```ts
 * getImageUrl('https://example.com/image', ImageSize.Small)
 * // => 'https://example.com/image/256x256'
 *
 * getImageUrl('https://example.com/image')
 * // => 'https://example.com/image/width_768_q70'
 *
 * getImageUrl(undefined, ImageSize.Big)
 * // => undefined
 * ```
 */
export function getImageUrl(baseUrl?: string, size: ImageSize = ImageSize.Medium): string | undefined {
    if (!baseUrl) {
        return undefined;
    }

    return `${baseUrl}${sizeSuffixes[size]}`;
}
